export default class DarkTeaseHover {
	constructor() {
		const grids = document.querySelectorAll('[data-projects-grid]');

		grids.forEach((grid) => {
			const teases = grid.querySelectorAll('[data-project-tease]');

			teases.forEach((tease) => {
				tease.addEventListener('mouseenter', () => {
					teases.forEach((t) => {
						if (t !== tease) t.classList.add('is-dimmed');
					});
				});

				tease.addEventListener('mouseleave', () => {
					teases.forEach((t) => t.classList.remove('is-dimmed'));
				});
			});
		});
	}
}